import { FolderIcon, IconBox } from "@hightouch/htui";
import { SchemaIconProps } from "./types";

export const AssetIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return (
    <IconBox color="orange" icon={<FolderIcon />} size={size} {...props} />
  );
};
